export default __webpack_public_path__ + "static/media/ayuntamiento.92de48f1.svg";